// extracted by mini-css-extract-plugin
export default {"expanded":"PaneHeader_expanded__jG+PH","collapseButton":"PaneHeader_collapseButton__DZ+c5","title":"PaneHeader_title__5cJeC","collapsed":"PaneHeader_collapsed__5tbnP"};